/**
 * insert competency Document Item create mutation
 * 
 * @param {string} mutationAliasName - alias name for the mutation
 * @param {string} competencyDocumentId
 * @param {string} abbreviatedStatement 
 * @param {string} fullStatement
 * @param {string} humanCodingScheme
 * @returns {string} - mutation string along with alias name. 
 */
export const competencyDocumentItemCreateMutation = (
  mutationAliasName,
  competencyDocumentId,
  abbreviatedStatement,
  fullStatement,
  humanCodingScheme
) => `${mutationAliasName}:competencyDocumentItemCreate (input: {
        documentId: "${competencyDocumentId}",
        abbreviatedStatement: "${abbreviatedStatement}",
        fullStatement: "${fullStatement}",
        humanCodingScheme:"${humanCodingScheme}"
    }) {
        documentItem {
          id
          documentId
          abbreviatedStatement
          fullStatement
          humanCodingScheme
          createdAt
          modifiedAt
        }
},`;

/**
 * competency Document Item association create mutation
 * 
 * @param {string} mutationAliasName - alias name for the mutation
 * @param {string} childItemId
 * @param {string} parentItemId 
 * @param {string} competencyDocumentId
 * @returns {string} - mutation string along with alias name. 
 */
export const competencyDocumentItemAssociationMutation = (
  mutationAliasName,
  childItemId,
  parentItemId,
  competencyDocumentId,
) => `${mutationAliasName}:competencyItemAssociationCreate (input: {
    associationType: isChildOf,
    originItemId: "${childItemId}",
    destinationItemId: "${parentItemId}",
    documentId:"${competencyDocumentId}"
  }) {
      association {
       id
       associationType
       originItemId
       destinationItemId
       createdAt
       createdById
    }
},`;

/**
 * Update competency Document Item create mutation
 * 
 * @param {string} mutationAliasName - alias name for the mutation
 * @param {string} documentItemId
 * @param {string} competencyDocumentId
 * @param {string} abbreviatedStatement 
 * @param {string} fullStatement
 * @param {string} humanCodingScheme
 * @returns {string} - mutation string along with alias name. 
 */
export const competencyDocumentItemUpdateMutation = (
  mutationAliasName,
  documentItemId,
  competencyDocumentId,
  abbreviatedStatement,
  fullStatement,
  humanCodingScheme
) => `${mutationAliasName}:CompetencyDocumentItemUpdate (input: {
        id: "${documentItemId}",
        documentId: "${competencyDocumentId}",
        abbreviatedStatement: "${abbreviatedStatement}",
        fullStatement: "${fullStatement}",
        humanCodingScheme:"${humanCodingScheme}"
    }) {
        documentItem {
          id
          documentId
          abbreviatedStatement
          fullStatement
          humanCodingScheme
          createdAt
          modifiedAt
        }
},`;

/**
 * competency Document Item association delete mutation
 * 
 * @param {string} mutationAliasName - alias name for the mutation
 * @param {string} associationId
 * @param {string} competencyDocumentId
 * @returns {string} - mutation string along with alias name. 
 */
export const competencyDocumentItemAssociationDeleteMutation = (
  mutationAliasName,
  associationId,
  competencyDocumentId,
) => `${mutationAliasName}:competencyItemAssociationDelete (input: {
  documentId: "${competencyDocumentId}",
  associationId: "${associationId}"
}) {
    documentId
    associationId
},`;



/**
 * delete all competency Document Item 
 * 
 * @param {string} mutationAliasName - alias name for the mutation
 * @param {string} competencyDocumentId
 * @param {string} itemId  
 */
export const competencyDocumentItemDeleteMutation = (
  mutationAliasName,
  competencyDocumentId,
  itemId,
) => `${mutationAliasName}:competencyDocumentItemDelete (input: {
        documentId: "${competencyDocumentId}",
        id: "${itemId}",
    }) {
        documentItem {
          id
          documentId
          abbreviatedStatement
          fullStatement
          humanCodingScheme
          createdAt
          modifiedAt
        }
},`;